import { IListColumnMeta, EFieldType, IFormFieldsMeta } from 'shared/types/Page.interface';
import { OrderRequestDto, OrderResponseDto } from 'shared/api';

// Статусы заказов
export const ORDER_STATUS_CONFIG = {
  [OrderResponseDto.status.COMPLETED]: { status: 'Завершено', color: '#722ed1', label: 'Завершено' },
  [OrderResponseDto.status.CANCELLED]: { status: 'Отменен', color: '#722ed1', label: 'Отменен' },
  [OrderResponseDto.status.NEW]: { status: 'Новый', color: '#722ed1', label: 'Новый' },
  [OrderResponseDto.status.IN_PROGRESS]: { status: 'В работе', color: '#722ed1', label: 'В работе' },
} as const;

// Типы работ
export const WORK_TYPE_CONFIG = {
  [OrderResponseDto.workType.MAINTENANCE]: { type: 'Регламентное обслуживание', color: '#1890ff', label: 'Регламентное обслуживание' },
  [OrderResponseDto.workType.REPAIR]: { type: 'Внеплановое обслуживание', color: '#ff4d4f', label: 'Внеплановое обслуживание' },
  [OrderResponseDto.workType.INSPECTION]: { type: 'Помощь в подготовке ТЗ', color: '#faad14', label: 'Помощь в подготовке ТЗ' },
  [OrderResponseDto.workType.UPGRADE]: { type: 'Запрос ЗИП', color: '#52c41a', label: 'Запрос ЗИП' },
} as const;

// Поля формы для создания/редактирования заказа
export const ORDER_FORM_FIELDS: IFormFieldsMeta = [
  {
    name: 'workType',
    label: 'Тип работы',
    type: EFieldType.select,
    required: true,
    options: [
      { value: OrderRequestDto.workType.MAINTENANCE, label: 'Регламентное обслуживание' },
      { value: OrderRequestDto.workType.REPAIR, label: 'Внеплановое обслуживание' },
      { value: OrderRequestDto.workType.INSPECTION, label: 'Помощь в подготовке ТЗ' },
      { value: OrderRequestDto.workType.UPGRADE, label: 'Запрос ЗИП' },
    ],
  },
  {
    name: 'comment',
    label: 'Комментарий',
    type: EFieldType.textarea,
  },
] as const;

// Конфигурация колонок таблицы заказов
export const ORDER_TABLE_COLUMNS: IListColumnMeta = [
  {
    title: 'Заказной код двигателя',
    type: EFieldType.input,
    dataIndex: 'orderCode',
    sortingPriority: 1,
  },
  {
    title: 'Серийный номер двигателя',
    type: EFieldType.input,
    dataIndex: 'serialNumber',
    sortingPriority: 2,
  },
  {
    title: 'Заказчик',
    type: EFieldType.input,
    dataIndex: 'ownerName',
    sortingPriority: 3,
  },
  {
    title: 'Компания',
    type: EFieldType.input,
    dataIndex: 'company',
    sortingPriority: 4,
  },
  {
    title: 'Дата создания',
    type: EFieldType.dateTime,
    dataIndex: 'createdAt',
    sourceFormat: 'YYYY-MM-DDTHH:mm:ss',
    targetFormat: 'DD.MM.YYYY HH:mm',
    sortingPriority: 6,
  },
  {
    title: 'Тип работы',
    type: EFieldType.select,
    dataIndex: 'workType',
    options: {
      [OrderResponseDto.workType.MAINTENANCE]: 'Регламентное обслуживание',
      [OrderResponseDto.workType.REPAIR]: 'Внеплановое обслуживание',
      [OrderResponseDto.workType.UPGRADE]: 'Запрос ЗИП',
      [OrderResponseDto.workType.INSPECTION]: 'Помощь в подготовке ТЗ',
    },
    sortingPriority: 2,
  },
  {
    title: 'Статус',
    type: EFieldType.colored,
    dataIndex: 'status',
    colorMap: {
      [OrderResponseDto.status.COMPLETED]: 'purple',
      [OrderResponseDto.status.CANCELLED]: 'red',
      [OrderResponseDto.status.NEW]: 'blue',
      [OrderResponseDto.status.IN_PROGRESS]: 'orange',
    },
    selectOptions: {
      [OrderResponseDto.status.COMPLETED]: 'Завершено',
      [OrderResponseDto.status.CANCELLED]: 'Отменен',
      [OrderResponseDto.status.NEW]: 'Новый',
      [OrderResponseDto.status.IN_PROGRESS]: 'В работе',
    },
    sortingPriority: 3,
  },
  {
    title: 'Комментарий',
    type: EFieldType.input,
    dataIndex: 'comment',
    sortingPriority: 5,
  },
];

// Типы для статуса и типа работы
export type OrderStatus = OrderResponseDto.status;
export type WorkType = OrderResponseDto.workType;
